import { render, staticRenderFns } from "./club-item.vue?vue&type=template&id=aae3cb3c&"
import script from "./club-item.vue?vue&type=script&lang=js&"
export * from "./club-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports